import { useState, useEffect, useRef } from 'react';

const CSS = `
.sg-root { width: 100%; padding: 0 0 64px; box-sizing: border-box; font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif; }
.sg-hero { background: linear-gradient(135deg, #1a237e 0%, #0d47a1 50%, #006064 100%); color: #fff; padding: 3rem 2rem 2.5rem; }
.sg-hero h1 { margin: 0 0 0.5rem; font-size: clamp(1.6rem, 4vw, 2.4rem); font-weight: 800; }
.sg-hero p { margin: 0; opacity: 0.85; font-size: 1.05rem; max-width: 600px; }
.sg-hero-meta { display: flex; gap: 1rem; margin-top: 1rem; flex-wrap: wrap; }
.sg-badge { background: rgba(255,255,255,0.18); border: 1px solid rgba(255,255,255,0.3); border-radius: 20px; padding: 0.25rem 0.75rem; font-size: 0.82rem; font-weight: 600; }
.sg-layout { display: grid; grid-template-columns: 240px minmax(0, 1fr); gap: 2rem; padding: 2rem; width: 100%; box-sizing: border-box; }
@media (max-width: 860px) { .sg-layout { grid-template-columns: 1fr; } .sg-nav { display: none; } }
.sg-nav { position: sticky; top: 1rem; height: fit-content; max-height: calc(100vh - 4rem); overflow-y: auto; }
.sg-nav-inner { background: var(--card-bg, #f8f9fa); border: 1px solid var(--border, #e0e0e0); border-radius: 12px; padding: 0.75rem 0; }
.sg-nav h3 { margin: 0 1rem 0.5rem; font-size: 0.75rem; text-transform: uppercase; letter-spacing: 0.08em; color: var(--muted, #666); font-weight: 700; }
.sg-nav a { display: flex; align-items: center; gap: 0.5rem; padding: 0.4rem 1rem; font-size: 0.85rem; color: var(--text, #333); text-decoration: none; border-left: 3px solid transparent; transition: all 0.15s; }
.sg-nav a:hover { background: var(--hover-bg, #e8f0fe); color: #1a73e8; }
.sg-nav a.active { border-left-color: #1a73e8; background: var(--hover-bg, #e8f0fe); color: #1a73e8; font-weight: 600; }
.sg-nav-num { width: 20px; height: 20px; border-radius: 50%; background: var(--border, #ddd); color: var(--muted, #666); font-size: 0.7rem; display: flex; align-items: center; justify-content: center; font-weight: 700; flex-shrink: 0; }
.sg-nav a.active .sg-nav-num { background: #1a73e8; color: #fff; }
.sg-main { min-width: 0; }
.sg-section { margin-bottom: 3rem; scroll-margin-top: 1rem; }
.sg-section-header { display: flex; align-items: center; gap: 1rem; margin-bottom: 1.5rem; padding-bottom: 0.75rem; border-bottom: 2px solid #1a73e8; }
.sg-section-num { width: 2.5rem; height: 2.5rem; border-radius: 50%; background: #1a73e8; color: #fff; font-size: 1rem; font-weight: 800; display: flex; align-items: center; justify-content: center; flex-shrink: 0; }
.sg-section-title { font-size: 1.3rem; font-weight: 700; color: var(--text, #1a1a1a); margin: 0; }
.sg-section-co { font-size: 0.75rem; color: var(--muted, #666); font-weight: 600; margin-left: auto; white-space: nowrap; }
.sg-card { background: var(--card-bg, #fff); border: 1px solid var(--border, #e8eaed); border-radius: 10px; padding: 1.25rem; margin-bottom: 1rem; }
.sg-card h3 { margin: 0 0 0.75rem; font-size: 1rem; font-weight: 700; color: var(--text, #1a1a1a); }
.sg-card h4 { margin: 1rem 0 0.5rem; font-size: 0.9rem; font-weight: 700; color: var(--text, #333); }
.sg-card p { margin: 0.4rem 0; font-size: 0.9rem; line-height: 1.6; color: var(--text, #333); }
.sg-card ul, .sg-card ol { margin: 0.4rem 0 0.4rem 1.4rem; padding: 0; }
.sg-card li { font-size: 0.9rem; line-height: 1.6; color: var(--text, #333); margin-bottom: 0.2rem; }
.sg-tip { background: #e8f5e9; border-left: 4px solid #43a047; border-radius: 0 8px 8px 0; padding: 0.75rem 1rem; margin: 0.75rem 0; font-size: 0.88rem; }
.sg-tip strong { color: #2e7d32; }
.sg-exam { background: #fff3e0; border-left: 4px solid #fb8c00; border-radius: 0 8px 8px 0; padding: 0.75rem 1rem; margin: 0.75rem 0; font-size: 0.88rem; }
.sg-exam strong { color: #e65100; }
.sg-warn { background: #fce4ec; border-left: 4px solid #e91e63; border-radius: 0 8px 8px 0; padding: 0.75rem 1rem; margin: 0.75rem 0; font-size: 0.88rem; }
.sg-warn strong { color: #c2185b; }
.sg-table-wrap { overflow-x: auto; margin: 0.75rem 0; }
.sg-table { width: 100%; border-collapse: collapse; font-size: 0.85rem; }
.sg-table th { background: #1a73e8; color: #fff; padding: 0.5rem 0.75rem; text-align: left; font-weight: 600; white-space: nowrap; }
.sg-table td { padding: 0.45rem 0.75rem; border-bottom: 1px solid var(--border, #e8eaed); vertical-align: top; }
.sg-table tr:nth-child(even) td { background: var(--row-alt, #f8f9fa); }
.sg-table tr:hover td { background: var(--hover-bg, #e8f0fe); }
.sg-grid2 { display: grid; grid-template-columns: repeat(auto-fit, minmax(280px, 1fr)); gap: 1rem; margin: 0.75rem 0; }
.sg-pill { display: inline-block; padding: 0.15rem 0.5rem; border-radius: 4px; font-size: 0.75rem; font-weight: 600; margin: 0.1rem; }
.sg-pill-blue { background: #e3f2fd; color: #1565c0; }
.sg-pill-green { background: #e8f5e9; color: #2e7d32; }
.sg-pill-orange { background: #fff3e0; color: #e65100; }
.sg-pill-red { background: #fce4ec; color: #c62828; }
.sg-pill-purple { background: #f3e5f5; color: #6a1b9a; }
.sg-exam-block { background: var(--card-bg, #fff); border: 1px solid #fb8c00; border-radius: 10px; padding: 1.25rem; margin: 1rem 0; }
.sg-exam-block h3 { margin: 0 0 1rem; font-size: 1rem; color: #e65100; }
.sg-q { margin-bottom: 1.2rem; }
.sg-q p { font-size: 0.9rem; color: var(--text, #333); margin: 0 0 0.5rem; font-weight: 600; }
.sg-q .sg-ans { font-size: 0.88rem; color: var(--muted, #555); background: var(--row-alt, #f8f9fa); border-radius: 6px; padding: 0.5rem 0.75rem; margin-top: 0.3rem; }
.sg-progress-bar { height: 4px; background: var(--border, #e0e0e0); border-radius: 2px; margin: 1rem 0; overflow: hidden; }
.sg-progress-fill { height: 100%; background: #1a73e8; border-radius: 2px; transition: width 0.4s; }
.sg-toc-mobile { display: none; }
@media (max-width: 860px) { .sg-toc-mobile { display: block; margin-bottom: 1rem; } }

[data-theme="dark"] .sg-root { --text: #e8eaed; --muted: #9aa0a6; --card-bg: #1e2124; --border: #3c4043; --hover-bg: #1a2340; --row-alt: #252830; }
[data-theme="dark"] .sg-nav-inner { background: #1e2124; border-color: #3c4043; }
[data-theme="dark"] .sg-nav h3 { color: #9aa0a6; }
[data-theme="dark"] .sg-nav a { color: #e8eaed; }
[data-theme="dark"] .sg-nav a:hover, [data-theme="dark"] .sg-nav a.active { background: #1a2340; }
[data-theme="dark"] .sg-tip { background: #1b3a1f; border-color: #43a047; }
[data-theme="dark"] .sg-exam { background: #2d1f00; border-color: #fb8c00; }
[data-theme="dark"] .sg-warn { background: #2d0014; border-color: #e91e63; }
[data-theme="dark"] .sg-table th { background: #0d47a1; }
[data-theme="dark"] .sg-table td { border-color: #3c4043; }
[data-theme="dark"] .sg-table tr:nth-child(even) td { background: #252830; }
[data-theme="dark"] .sg-table tr:hover td { background: #1a2340; }
[data-theme="dark"] .sg-exam-block { background: #1e2124; border-color: #fb8c00; }
[data-theme="dark"] .sg-q .sg-ans { background: #252830; }
[data-theme="dark"] .sg-pill-blue { background: #0d2a4a; color: #82b1ff; }
[data-theme="dark"] .sg-pill-green { background: #0d2a1a; color: #69f0ae; }
[data-theme="dark"] .sg-pill-orange { background: #2a1500; color: #ffb74d; }
[data-theme="dark"] .sg-pill-red { background: #2a0010; color: #ff8a80; }
[data-theme="dark"] .sg-pill-purple { background: #1e0a2a; color: #ce93d8; }

@media (prefers-color-scheme: dark) {
  .sg-root:not([data-theme="light"] .sg-root) {
    --text: #e8eaed; --muted: #9aa0a6; --card-bg: #1e2124; --border: #3c4043;
    --hover-bg: #1a2340; --row-alt: #252830;
  }
}
`;

const MODULES = [
  {
    id: 'm1',
    num: 1,
    title: 'Cloud Foundations & IAM',
    co: 'CO 1',
    icon: '☁️',
    content: () => (
      <>
        <div className="sg-card">
          <h3>Cloud Computing Models</h3>
          <div className="sg-table-wrap">
            <table className="sg-table">
              <thead><tr><th>Model</th><th>AWS Manages</th><th>Customer Manages</th><th>Examples</th></tr></thead>
              <tbody>
                <tr><td><strong>IaaS</strong></td><td>Hardware, virtualisation, networking</td><td>OS, runtime, app, data</td><td>EC2, EBS, VPC</td></tr>
                <tr><td><strong>PaaS</strong></td><td>Everything except app & data</td><td>Application, data</td><td>Elastic Beanstalk, RDS</td></tr>
                <tr><td><strong>SaaS</strong></td><td>Everything</td><td>Use the service</td><td>WorkMail, Chime</td></tr>
                <tr><td><strong>FaaS</strong></td><td>Infra + runtime</td><td>Function code only</td><td>Lambda</td></tr>
                <tr><td><strong>CaaS</strong></td><td>Cluster control plane</td><td>Container images, configs</td><td>ECS, EKS</td></tr>
                <tr><td><strong>DBaaS</strong></td><td>Database engine + patching</td><td>Schema, queries</td><td>RDS, DynamoDB</td></tr>
                <tr><td><strong>STaaS</strong></td><td>Storage infrastructure</td><td>Objects/data</td><td>S3, EFS</td></tr>
                <tr><td><strong>DRaaS</strong></td><td>DR replication, failover automation</td><td>Recovery objectives</td><td>AWS DRS, Backup</td></tr>
              </tbody>
            </table>
          </div>
          <div className="sg-tip"><strong>💡 Tip:</strong> Shared responsibility model — AWS = security OF the cloud; Customer = security IN the cloud.</div>
        </div>

        <div className="sg-card">
          <h3>AWS Global Infrastructure</h3>
          <div className="sg-grid2">
            <div>
              <h4>Regions</h4>
              <ul>
                <li>Geographically isolated areas</li>
                <li>Each has ≥3 Availability Zones</li>
                <li>Data sovereignty — data stays in region unless you move it</li>
                <li>Choose based on: latency, compliance, service availability, cost</li>
              </ul>
            </div>
            <div>
              <h4>Availability Zones (AZs)</h4>
              <ul>
                <li>One or more discrete data centers with redundant power, networking</li>
                <li>Connected via low-latency links</li>
                <li>Isolated from failures in other AZs</li>
                <li>Best practice: deploy across ≥2 AZs for HA</li>
              </ul>
            </div>
          </div>
          <h4>Edge Locations / Points of Presence</h4>
          <p>Used by CloudFront CDN and Route 53 for low-latency content delivery. 400+ globally. Separate from Regions and AZs.</p>
        </div>

        <div className="sg-card">
          <h3>IAM (Identity & Access Management)</h3>
          <div className="sg-grid2">
            <div>
              <h4>Core Concepts</h4>
              <ul>
                <li><strong>Users</strong> — individual people/services; long-term credentials</li>
                <li><strong>Groups</strong> — collection of users; apply policies to group</li>
                <li><strong>Roles</strong> — assumed by services/users; short-term credentials (STS)</li>
                <li><strong>Policies</strong> — JSON documents defining permissions</li>
              </ul>
            </div>
            <div>
              <h4>Policy Types</h4>
              <ul>
                <li><strong>Identity-based</strong> — attached to user/group/role</li>
                <li><strong>Resource-based</strong> — attached to resource (S3 bucket policy)</li>
                <li><strong>SCPs</strong> — AWS Organizations service control policies</li>
                <li><strong>Permission boundaries</strong> — max permissions an entity can have</li>
              </ul>
            </div>
          </div>
          <div className="sg-tip"><strong>🔑 Principle of Least Privilege:</strong> Grant only the permissions required to perform a task. Start with deny all, then add required permissions.</div>
          <h4>IAM Best Practices</h4>
          <ul>
            <li>Never use root account for daily tasks — enable MFA on root immediately</li>
            <li>Use IAM Roles for EC2 instances (not access keys stored in code)</li>
            <li>Rotate access keys regularly</li>
            <li>Use IAM Access Analyzer to identify over-permissive policies</li>
            <li>Enable CloudTrail to audit all API calls</li>
          </ul>
        </div>

        <div className="sg-exam-block">
          <h3>🎯 Exam Questions — Module 1</h3>
          <div className="sg-q">
            <p>Q1. Which AWS service provides a managed, scalable DNS and health checking service?</p>
            <div className="sg-ans">✅ Amazon Route 53 — it's AWS's authoritative DNS service with health checks, routing policies (failover, weighted, geolocation, latency).</div>
          </div>
          <div className="sg-q">
            <p>Q2. A company needs to give an EC2 instance access to S3 without storing credentials. What should they use?</p>
            <div className="sg-ans">✅ IAM Role attached to the EC2 instance. The instance profile delivers temporary credentials via the metadata service (169.254.169.254).</div>
          </div>
          <div className="sg-q">
            <p>Q3. What is the difference between an IAM Role and an IAM User?</p>
            <div className="sg-ans">✅ Users have long-term credentials (password + access keys). Roles use temporary credentials issued by STS, assumed by services, users, or federated identities. Roles don't have their own credentials stored.</div>
          </div>
          <div className="sg-q">
            <p>Q4. Under the Shared Responsibility Model, which of the following is AWS's responsibility?</p>
            <div className="sg-ans">✅ Physical security of data centers, hardware maintenance, hypervisor patching, global network infrastructure. Customer is responsible for guest OS patching, security groups, encryption, IAM policies.</div>
          </div>
        </div>
      </>
    ),
  },
  {
    id: 'm2',
    num: 2,
    title: 'Compute & Storage Services',
    co: 'CO 4',
    icon: '⚡',
    content: () => (
      <>
        <div className="sg-card">
          <h3>EC2 Instance Types</h3>
          <div className="sg-table-wrap">
            <table className="sg-table">
              <thead><tr><th>Family</th><th>Optimised For</th><th>Use Cases</th><th>Examples</th></tr></thead>
              <tbody>
                <tr><td><strong>General Purpose</strong></td><td>Balanced CPU/RAM</td><td>Web servers, dev environments</td><td>t3, m6i</td></tr>
                <tr><td><strong>Compute Optimised</strong></td><td>High CPU-to-RAM ratio</td><td>HPC, batch, gaming servers</td><td>c6i, c7g</td></tr>
                <tr><td><strong>Memory Optimised</strong></td><td>High RAM</td><td>In-memory DBs, real-time analytics</td><td>r6i, x2iedn</td></tr>
                <tr><td><strong>Storage Optimised</strong></td><td>High I/O throughput</td><td>NoSQL DBs, data warehousing</td><td>i4i, d3</td></tr>
                <tr><td><strong>Accelerated</strong></td><td>GPU/FPGA</td><td>ML inference, graphics rendering</td><td>p4, g5, inf2</td></tr>
                <tr><td><strong>HPC Optimised</strong></td><td>Cluster networking</td><td>Tightly coupled HPC workloads</td><td>hpc6id</td></tr>
              </tbody>
            </table>
          </div>
        </div>

        <div className="sg-card">
          <h3>EC2 Pricing Models</h3>
          <div className="sg-table-wrap">
            <table className="sg-table">
              <thead><tr><th>Model</th><th>Discount vs On-Demand</th><th>Commitment</th><th>Best For</th></tr></thead>
              <tbody>
                <tr><td><strong>On-Demand</strong></td><td>Baseline (no discount)</td><td>None</td><td>Short-term, unpredictable workloads</td></tr>
                <tr><td><strong>Reserved Instances (1yr)</strong></td><td>Up to 40%</td><td>1 year</td><td>Steady-state workloads</td></tr>
                <tr><td><strong>Reserved Instances (3yr)</strong></td><td>Up to 72%</td><td>3 years</td><td>Long-running stable applications</td></tr>
                <tr><td><strong>Savings Plans</strong></td><td>Up to 66%</td><td>1 or 3 years</td><td>Flexible compute (EC2, Fargate, Lambda)</td></tr>
                <tr><td><strong>Spot Instances</strong></td><td>Up to 90%</td><td>None (can be interrupted)</td><td>Fault-tolerant batch, big data, CI/CD</td></tr>
                <tr><td><strong>Dedicated Hosts</strong></td><td>Varies</td><td>On-demand or reserved</td><td>Compliance, BYOL, socket-level licensing</td></tr>
              </tbody>
            </table>
          </div>
          <div className="sg-exam"><strong>⚠️ Exam trap:</strong> Spot Instances can be interrupted with 2-minute warning. Never use for stateful production databases or anything that can't tolerate interruption.</div>
        </div>

        <div className="sg-card">
          <h3>EC2 Auto Scaling</h3>
          <div className="sg-grid2">
            <div>
              <h4>Scaling Policies</h4>
              <ul>
                <li><strong>Simple</strong> — single CloudWatch alarm triggers scale-up/down</li>
                <li><strong>Step</strong> — different step adjustments based on alarm breach size</li>
                <li><strong>Target Tracking</strong> — maintain a metric at target value (e.g., CPU 50%)</li>
                <li><strong>Scheduled</strong> — scale at a specific time (e.g., business hours)</li>
                <li><strong>Predictive</strong> — ML-based forecasting of future load</li>
              </ul>
            </div>
            <div>
              <h4>Launch Templates vs Launch Configurations</h4>
              <ul>
                <li>Launch Templates are newer — support versioning, spot + on-demand mix</li>
                <li>Launch Configurations are legacy — no versioning</li>
                <li>AWS recommends Launch Templates for all new deployments</li>
              </ul>
            </div>
          </div>
        </div>

        <div className="sg-card">
          <h3>S3 Storage Classes</h3>
          <div className="sg-table-wrap">
            <table className="sg-table">
              <thead><tr><th>Class</th><th>Availability</th><th>Min Duration</th><th>Retrieval</th><th>Use Case</th></tr></thead>
              <tbody>
                <tr><td><strong>S3 Standard</strong></td><td>99.99%</td><td>None</td><td>Milliseconds</td><td>Frequently accessed data</td></tr>
                <tr><td><strong>S3 Intelligent-Tiering</strong></td><td>99.9%</td><td>None</td><td>Milliseconds</td><td>Unknown/changing access patterns</td></tr>
                <tr><td><strong>S3 Standard-IA</strong></td><td>99.9%</td><td>30 days</td><td>Milliseconds</td><td>Infrequent access, needs fast retrieval</td></tr>
                <tr><td><strong>S3 One Zone-IA</strong></td><td>99.5%</td><td>30 days</td><td>Milliseconds</td><td>Infrequent, re-creatable data</td></tr>
                <tr><td><strong>S3 Glacier Instant</strong></td><td>99.9%</td><td>90 days</td><td>Milliseconds</td><td>Archive, quarterly access</td></tr>
                <tr><td><strong>S3 Glacier Flexible</strong></td><td>99.99%</td><td>90 days</td><td>1 min – 12 hr</td><td>Archive, rare access</td></tr>
                <tr><td><strong>S3 Glacier Deep Archive</strong></td><td>99.99%</td><td>180 days</td><td>12 – 48 hr</td><td>Compliance retention 7-10 years</td></tr>
              </tbody>
            </table>
          </div>
        </div>

        <div className="sg-card">
          <h3>EBS Volume Types</h3>
          <div className="sg-table-wrap">
            <table className="sg-table">
              <thead><tr><th>Type</th><th>IOPS</th><th>Throughput</th><th>Use Case</th></tr></thead>
              <tbody>
                <tr><td><strong>gp3</strong> (General Purpose SSD)</td><td>Up to 16,000</td><td>1,000 MB/s</td><td>Default for most workloads</td></tr>
                <tr><td><strong>gp2</strong> (General Purpose SSD)</td><td>Up to 16,000 (3 IOPS/GB)</td><td>250 MB/s</td><td>Legacy default, being replaced by gp3</td></tr>
                <tr><td><strong>io2 Block Express</strong></td><td>Up to 256,000</td><td>4,000 MB/s</td><td>Critical databases (Oracle, SQL Server)</td></tr>
                <tr><td><strong>io1</strong> (Provisioned SSD)</td><td>Up to 64,000</td><td>1,000 MB/s</td><td>I/O-intensive DBs</td></tr>
                <tr><td><strong>st1</strong> (Throughput HDD)</td><td>500</td><td>500 MB/s</td><td>Big data, log processing</td></tr>
                <tr><td><strong>sc1</strong> (Cold HDD)</td><td>250</td><td>250 MB/s</td><td>Infrequently accessed data</td></tr>
              </tbody>
            </table>
          </div>
        </div>

        <div className="sg-card">
          <h3>Serverless Compute — AWS Lambda</h3>
          <div className="sg-grid2">
            <div>
              <h4>Key Properties</h4>
              <ul>
                <li>Max execution: 15 minutes</li>
                <li>Memory: 128 MB – 10,240 MB</li>
                <li>No server provisioning — pay per invocation + duration</li>
                <li>Scales automatically to concurrency limits</li>
                <li>Default concurrent executions: 1,000 per region</li>
              </ul>
            </div>
            <div>
              <h4>Trigger Sources</h4>
              <ul>
                <li>API Gateway, ALB (HTTP)</li>
                <li>S3 events (object created/deleted)</li>
                <li>DynamoDB Streams</li>
                <li>SQS, SNS, Kinesis</li>
                <li>EventBridge rules</li>
                <li>CloudFront (Lambda@Edge)</li>
              </ul>
            </div>
          </div>
        </div>

        <div className="sg-exam-block">
          <h3>🎯 Exam Questions — Module 2</h3>
          <div className="sg-q">
            <p>Q1. A startup needs to run batch processing that can be interrupted. Which EC2 pricing model minimises cost?</p>
            <div className="sg-ans">✅ Spot Instances — up to 90% discount. Use with checkpointing so the job can resume after interruption.</div>
          </div>
          <div className="sg-q">
            <p>Q2. What S3 storage class automatically moves data between tiers based on access patterns?</p>
            <div className="sg-ans">✅ S3 Intelligent-Tiering — monitors access and moves objects automatically between frequent, infrequent, archive tiers. No retrieval fees, small monthly monitoring fee.</div>
          </div>
          <div className="sg-q">
            <p>Q3. An application needs consistent 10,000 IOPS for a database. Which EBS type is appropriate?</p>
            <div className="sg-ans">✅ io1 or io2 — Provisioned IOPS SSD. gp2/gp3 can burst but io1/io2 provide guaranteed sustained IOPS.</div>
          </div>
        </div>
      </>
    ),
  },
  {
    id: 'm3',
    num: 3,
    title: 'Networking & Content Delivery',
    co: 'CO 4',
    icon: '🌐',
    content: () => (
      <>
        <div className="sg-card">
          <h3>VPC (Virtual Private Cloud)</h3>
          <div className="sg-grid2">
            <div>
              <h4>VPC Components</h4>
              <ul>
                <li><strong>Subnets</strong> — public (IGW route) or private (no IGW)</li>
                <li><strong>Route Tables</strong> — control traffic routing between subnets</li>
                <li><strong>Internet Gateway (IGW)</strong> — public internet access</li>
                <li><strong>NAT Gateway</strong> — private subnet outbound internet (managed, HA)</li>
                <li><strong>NAT Instance</strong> — EC2-based, legacy, single point of failure</li>
                <li><strong>VPC Peering</strong> — private routing between VPCs (same/cross account, same/cross region)</li>
                <li><strong>Transit Gateway</strong> — hub-and-spoke for 100s of VPCs</li>
              </ul>
            </div>
            <div>
              <h4>Security Layers</h4>
              <ul>
                <li><strong>Security Groups</strong> — stateful, instance-level firewall. Only allow rules, no deny rules. Return traffic auto-allowed.</li>
                <li><strong>NACLs</strong> — stateless, subnet-level. Explicit allow AND deny. Must allow both directions. Rule priority = number (lower = evaluated first).</li>
                <li><strong>VPC Flow Logs</strong> — log accepted/rejected traffic to CW Logs or S3</li>
              </ul>
            </div>
          </div>
          <div className="sg-warn"><strong>⚡ Key difference:</strong> Security Groups are stateful (response traffic automatic). NACLs are stateless (must explicitly allow inbound AND outbound for each direction).</div>
        </div>

        <div className="sg-card">
          <h3>Elastic Load Balancing (ELB)</h3>
          <div className="sg-table-wrap">
            <table className="sg-table">
              <thead><tr><th>Type</th><th>Layer</th><th>Protocol</th><th>Use Case</th></tr></thead>
              <tbody>
                <tr><td><strong>Application LB (ALB)</strong></td><td>L7</td><td>HTTP, HTTPS, gRPC</td><td>Web apps, microservices, path/host-based routing</td></tr>
                <tr><td><strong>Network LB (NLB)</strong></td><td>L4</td><td>TCP, UDP, TLS</td><td>Ultra-low latency, static IP, millions of RPS</td></tr>
                <tr><td><strong>Gateway LB (GWLB)</strong></td><td>L3</td><td>IP</td><td>Third-party virtual appliances (IDS/IPS, firewalls)</td></tr>
                <tr><td><strong>Classic LB</strong></td><td>L4/L7</td><td>HTTP, TCP</td><td>Legacy — not recommended for new deployments</td></tr>
              </tbody>
            </table>
          </div>
          <div className="sg-tip"><strong>ALB features:</strong> Content-based routing (URL path, headers, host), sticky sessions, WebSocket, Lambda targets, WAF integration.</div>
          <div className="sg-tip"><strong>NLB features:</strong> Static Elastic IP per AZ, preserve source IP, lowest latency, PrivateLink endpoint.</div>
        </div>

        <div className="sg-card">
          <h3>Route 53 Routing Policies</h3>
          <div className="sg-table-wrap">
            <table className="sg-table">
              <thead><tr><th>Policy</th><th>How it works</th><th>Use Case</th></tr></thead>
              <tbody>
                <tr><td><strong>Simple</strong></td><td>One record, one or more values (random selection)</td><td>Single resource</td></tr>
                <tr><td><strong>Weighted</strong></td><td>Distribute traffic by weight percentages</td><td>A/B testing, gradual deployments</td></tr>
                <tr><td><strong>Latency</strong></td><td>Route to region with lowest latency to user</td><td>Multi-region performance</td></tr>
                <tr><td><strong>Failover</strong></td><td>Active-passive; route to secondary if health check fails</td><td>Disaster recovery</td></tr>
                <tr><td><strong>Geolocation</strong></td><td>Route based on user's geographic location</td><td>Compliance, localisation</td></tr>
                <tr><td><strong>Geoproximity</strong></td><td>Route based on location + bias</td><td>Shift traffic between regions</td></tr>
                <tr><td><strong>Multi-value</strong></td><td>Return multiple healthy IPs (like Simple + health checks)</td><td>Client-side load balancing</td></tr>
              </tbody>
            </table>
          </div>
        </div>

        <div className="sg-card">
          <h3>CloudFront CDN</h3>
          <div className="sg-grid2">
            <div>
              <h4>Key Features</h4>
              <ul>
                <li>400+ PoPs (edge locations) globally</li>
                <li>Cache static/dynamic content at edge</li>
                <li>HTTPS with ACM certificates (free)</li>
                <li>OAC (Origin Access Control) restricts S3 to CloudFront only</li>
                <li>Lambda@Edge — run code at edge locations</li>
                <li>CloudFront Functions — lightweight JS at edge</li>
              </ul>
            </div>
            <div>
              <h4>Cache Invalidation</h4>
              <ul>
                <li>Invalidate paths: /* or /images/*.jpg</li>
                <li>First 1,000 paths/month free</li>
                <li>Use versioned filenames (better practice) to avoid invalidation costs</li>
                <li>TTL: min 0s, max 31,536,000s (1 year). Default: 86,400s (24hr)</li>
              </ul>
            </div>
          </div>
        </div>

        <div className="sg-exam-block">
          <h3>🎯 Exam Questions — Module 3</h3>
          <div className="sg-q">
            <p>Q1. A company needs to route traffic between multiple VPCs and on-premises networks efficiently. What AWS service should they use?</p>
            <div className="sg-ans">✅ AWS Transit Gateway — acts as a hub, supports 1000s of VPC attachments, simplifies complex peering topologies.</div>
          </div>
          <div className="sg-q">
            <p>Q2. What is the difference between a Security Group and a NACL?</p>
            <div className="sg-ans">✅ Security Group: stateful, instance-level, only allow rules, return traffic automatic. NACL: stateless, subnet-level, allow AND deny rules, return traffic needs explicit rule.</div>
          </div>
          <div className="sg-q">
            <p>Q3. A web application needs path-based routing (/api/* to backend, /* to frontend). Which load balancer should be used?</p>
            <div className="sg-ans">✅ Application Load Balancer (ALB) — supports path-based and host-based routing rules at Layer 7.</div>
          </div>
        </div>
      </>
    ),
  },
  {
    id: 'm4',
    num: 4,
    title: 'Database Services',
    co: 'CO 4',
    icon: '🗄️',
    content: () => (
      <>
        <div className="sg-card">
          <h3>RDS (Relational Database Service)</h3>
          <div className="sg-grid2">
            <div>
              <h4>Supported Engines</h4>
              <ul>
                <li>MySQL, MariaDB, PostgreSQL</li>
                <li>Oracle, SQL Server</li>
                <li>Amazon Aurora (MySQL/PostgreSQL-compatible)</li>
              </ul>
              <h4>Multi-AZ</h4>
              <ul>
                <li>Synchronous replication to standby AZ</li>
                <li>Automatic failover (60-120 seconds)</li>
                <li>Standby NOT used for reads — HA only</li>
                <li>DNS endpoint stays same after failover</li>
              </ul>
            </div>
            <div>
              <h4>Read Replicas</h4>
              <ul>
                <li>Asynchronous replication</li>
                <li>Up to 5 read replicas per primary</li>
                <li>Can be in different AZ or region (cross-region)</li>
                <li>Can be promoted to standalone DB</li>
                <li>Must connect to replica endpoint (different from primary)</li>
              </ul>
            </div>
          </div>
          <div className="sg-table-wrap" style={{marginTop:'1rem'}}>
            <table className="sg-table">
              <thead><tr><th>Feature</th><th>Multi-AZ</th><th>Read Replica</th></tr></thead>
              <tbody>
                <tr><td>Purpose</td><td>High Availability / Disaster Recovery</td><td>Read scalability / performance</td></tr>
                <tr><td>Replication</td><td>Synchronous</td><td>Asynchronous</td></tr>
                <tr><td>Readable?</td><td>No (standby)</td><td>Yes</td></tr>
                <tr><td>Failover</td><td>Automatic</td><td>Manual promotion</td></tr>
                <tr><td>Cross-region</td><td>No (same region)</td><td>Yes</td></tr>
                <tr><td>Use for</td><td>Uptime, compliance</td><td>Reporting, analytics, DR</td></tr>
              </tbody>
            </table>
          </div>
        </div>

        <div className="sg-card">
          <h3>Amazon Aurora</h3>
          <div className="sg-grid2">
            <div>
              <h4>Aurora Architecture</h4>
              <ul>
                <li>Distributed storage: 6 copies across 3 AZs</li>
                <li>Can tolerate 2 AZ failures (writes), 3 AZ failures (reads)</li>
                <li>Up to 15 Aurora Replicas (auto-failover)</li>
                <li>Storage auto-grows 10GB → 128TB</li>
                <li>5× faster than MySQL, 3× faster than PostgreSQL</li>
              </ul>
            </div>
            <div>
              <h4>Aurora Serverless v2</h4>
              <ul>
                <li>Auto-scales capacity in fine-grained increments (0.5 ACU steps)</li>
                <li>Scales to zero (v2: scales to minimum, not fully zero)</li>
                <li>Ideal for variable/unpredictable workloads</li>
                <li>ACU = Aurora Capacity Unit (~2 GB RAM each)</li>
              </ul>
            </div>
          </div>
        </div>

        <div className="sg-card">
          <h3>DynamoDB (NoSQL)</h3>
          <div className="sg-grid2">
            <div>
              <h4>Key Properties</h4>
              <ul>
                <li>Fully managed, serverless key-value + document store</li>
                <li>Single-digit millisecond latency at any scale</li>
                <li>Scales automatically with on-demand mode</li>
                <li>DynamoDB Streams — event-driven processing</li>
                <li>Global Tables — multi-region active-active</li>
              </ul>
            </div>
            <div>
              <h4>Capacity Modes</h4>
              <ul>
                <li><strong>On-Demand</strong> — pay per request, auto-scale, unpredictable traffic</li>
                <li><strong>Provisioned</strong> — set RCU/WCU, auto-scaling option, predictable workloads</li>
                <li><strong>RCU</strong> = 1 strongly consistent read of 4KB/s</li>
                <li><strong>WCU</strong> = 1 write of 1KB/s</li>
              </ul>
            </div>
          </div>
          <div className="sg-tip"><strong>DAX (DynamoDB Accelerator):</strong> In-memory caching layer for DynamoDB. Read latency from milliseconds to microseconds. Write-through cache. For read-heavy applications.</div>
        </div>

        <div className="sg-card">
          <h3>Other AWS Database Services</h3>
          <div className="sg-table-wrap">
            <table className="sg-table">
              <thead><tr><th>Service</th><th>Type</th><th>Use Case</th></tr></thead>
              <tbody>
                <tr><td><strong>ElastiCache</strong></td><td>In-memory (Redis/Memcached)</td><td>Session caching, leaderboards, real-time analytics</td></tr>
                <tr><td><strong>Redshift</strong></td><td>Data warehouse (columnar)</td><td>OLAP analytics, petabyte-scale BI queries</td></tr>
                <tr><td><strong>Neptune</strong></td><td>Graph database</td><td>Social networks, fraud detection, knowledge graphs</td></tr>
                <tr><td><strong>DocumentDB</strong></td><td>Document (MongoDB-compatible)</td><td>Content management, catalogs, user profiles</td></tr>
                <tr><td><strong>Keyspaces</strong></td><td>Wide-column (Cassandra-compatible)</td><td>IoT timeseries, industrial telemetry</td></tr>
                <tr><td><strong>Timestream</strong></td><td>Time-series</td><td>IoT metrics, DevOps monitoring</td></tr>
                <tr><td><strong>QLDB</strong></td><td>Ledger (immutable)</td><td>Financial transactions audit trail</td></tr>
              </tbody>
            </table>
          </div>
        </div>

        <div className="sg-exam-block">
          <h3>🎯 Exam Questions — Module 4</h3>
          <div className="sg-q">
            <p>Q1. A company wants to offload read traffic from their RDS MySQL instance. What should they create?</p>
            <div className="sg-ans">✅ RDS Read Replicas — asynchronous replicas that can serve read traffic. Must update application to use replica endpoint for reads.</div>
          </div>
          <div className="sg-q">
            <p>Q2. Which DynamoDB feature allows for microsecond latency reads?</p>
            <div className="sg-ans">✅ DAX (DynamoDB Accelerator) — in-memory caching service compatible with DynamoDB API. Reduces read latency from milliseconds to microseconds.</div>
          </div>
          <div className="sg-q">
            <p>Q3. A financial application needs an immutable audit log of all transactions. Which service fits?</p>
            <div className="sg-ans">✅ Amazon QLDB — quantum ledger database with cryptographically verifiable transaction log. Immutable, transparent, serverless.</div>
          </div>
        </div>
      </>
    ),
  },
  {
    id: 'm5',
    num: 5,
    title: 'Management Tools & Cost Management',
    co: 'CO 3',
    icon: '📊',
    content: () => (
      <>
        <div className="sg-card">
          <h3>Monitoring & Observability</h3>
          <div className="sg-grid2">
            <div>
              <h4>Amazon CloudWatch</h4>
              <ul>
                <li><strong>Metrics</strong> — time-series data from AWS services</li>
                <li><strong>Alarms</strong> — trigger actions on threshold breach (SNS, Auto Scaling, EC2 action)</li>
                <li><strong>Logs</strong> — collect, monitor, store log files</li>
                <li><strong>Dashboards</strong> — visualise metrics</li>
                <li><strong>Events / EventBridge</strong> — react to state changes</li>
                <li><strong>Container Insights</strong> — ECS/EKS performance</li>
              </ul>
            </div>
            <div>
              <h4>AWS CloudTrail</h4>
              <ul>
                <li>Records all API calls across your AWS account</li>
                <li>Who did what, when, from where</li>
                <li>Management events + data events</li>
                <li>90-day history free; deliver to S3 for longer retention</li>
                <li>CloudTrail Insights — detect unusual API activity</li>
                <li>Use for security audit, compliance, troubleshooting</li>
              </ul>
            </div>
          </div>
        </div>

        <div className="sg-card">
          <h3>Infrastructure as Code</h3>
          <div className="sg-grid2">
            <div>
              <h4>AWS CloudFormation</h4>
              <ul>
                <li>Template-based IaC (JSON or YAML)</li>
                <li>Stacks — collection of resources managed as unit</li>
                <li>Stack Sets — deploy to multiple accounts/regions</li>
                <li>Change Sets — preview changes before applying</li>
                <li>Drift Detection — identify manual changes</li>
                <li>No additional cost (pay for resources created)</li>
              </ul>
            </div>
            <div>
              <h4>AWS Systems Manager (SSM)</h4>
              <ul>
                <li>Parameter Store — secure config/secrets storage</li>
                <li>Session Manager — shell access without SSH/bastion</li>
                <li>Patch Manager — automated OS patching</li>
                <li>Run Command — execute commands across fleet</li>
                <li>Inventory — track software/config across instances</li>
              </ul>
            </div>
          </div>
        </div>

        <div className="sg-card">
          <h3>Cost Management Tools</h3>
          <div className="sg-table-wrap">
            <table className="sg-table">
              <thead><tr><th>Tool</th><th>Purpose</th><th>Key Features</th></tr></thead>
              <tbody>
                <tr><td><strong>AWS Cost Explorer</strong></td><td>Visualise and analyse costs</td><td>12-month history, 12-month forecast, rightsizing recommendations</td></tr>
                <tr><td><strong>AWS Budgets</strong></td><td>Set cost/usage alerts</td><td>Alert at % threshold, reserve coverage alerts, action-triggered</td></tr>
                <tr><td><strong>Cost &amp; Usage Report</strong></td><td>Detailed billing data</td><td>Hourly/daily granularity, delivery to S3, Athena queryable</td></tr>
                <tr><td><strong>Trusted Advisor</strong></td><td>Best practice recommendations</td><td>Cost, security, fault tolerance, performance, service limits</td></tr>
                <tr><td><strong>Compute Optimizer</strong></td><td>Rightsizing recommendations</td><td>ML-based EC2, Lambda, ECS, EBS recommendations</td></tr>
                <tr><td><strong>Savings Plans</strong></td><td>Commit for discounts</td><td>Compute (most flexible), EC2 Instance, SageMaker</td></tr>
              </tbody>
            </table>
          </div>
        </div>

        <div className="sg-card">
          <h3>AWS Organizations</h3>
          <div className="sg-grid2">
            <div>
              <h4>Structure</h4>
              <ul>
                <li>Management Account — root of organization, billing payer</li>
                <li>Organizational Units (OUs) — hierarchical groupings</li>
                <li>Member Accounts — individual AWS accounts</li>
                <li>Consolidated Billing — single bill, volume discounts</li>
              </ul>
            </div>
            <div>
              <h4>Service Control Policies (SCPs)</h4>
              <ul>
                <li>Apply to OUs or accounts — maximum permissions</li>
                <li>Even admins in member accounts can't exceed SCP limits</li>
                <li>SCPs don't apply to management account</li>
                <li>Use to enforce compliance (e.g., block regions, require tags)</li>
              </ul>
            </div>
          </div>
        </div>

        <div className="sg-exam-block">
          <h3>🎯 Exam Questions — Module 5</h3>
          <div className="sg-q">
            <p>Q1. A company wants to enforce that no one in their AWS Organization can disable CloudTrail. What should they use?</p>
            <div className="sg-ans">✅ Service Control Policy (SCP) — apply a Deny SCP to all OUs/accounts that blocks cloudtrail:StopLogging and cloudtrail:DeleteTrail.</div>
          </div>
          <div className="sg-q">
            <p>Q2. How can a team access an EC2 instance via shell without opening port 22 or using a bastion host?</p>
            <div className="sg-ans">✅ AWS Systems Manager Session Manager — provides browser-based or CLI shell access without inbound ports, SSH keys, or bastion hosts. All sessions logged to CloudWatch Logs/S3.</div>
          </div>
        </div>
      </>
    ),
  },
  {
    id: 'm6',
    num: 6,
    title: 'Security & Compliance',
    co: 'CO 2',
    icon: '🔒',
    content: () => (
      <>
        <div className="sg-card">
          <h3>Key Security Services</h3>
          <div className="sg-table-wrap">
            <table className="sg-table">
              <thead><tr><th>Service</th><th>Category</th><th>What it does</th></tr></thead>
              <tbody>
                <tr><td><strong>AWS Shield Standard</strong></td><td>DDoS Protection</td><td>Free, automatic DDoS protection for all customers</td></tr>
                <tr><td><strong>AWS Shield Advanced</strong></td><td>DDoS Protection</td><td>Enhanced DDoS, 24/7 DRT team, cost protection, $3,000/month</td></tr>
                <tr><td><strong>AWS WAF</strong></td><td>Web Application Firewall</td><td>Block common web exploits (SQLi, XSS), rate limiting, geo-block</td></tr>
                <tr><td><strong>Amazon GuardDuty</strong></td><td>Threat Detection</td><td>ML-based anomaly detection from CloudTrail, VPC Flow Logs, DNS logs</td></tr>
                <tr><td><strong>Amazon Inspector</strong></td><td>Vulnerability Assessment</td><td>Automated CVE scanning of EC2, Lambda, ECR container images</td></tr>
                <tr><td><strong>AWS Macie</strong></td><td>Data Security</td><td>ML to discover and protect sensitive data (PII) in S3</td></tr>
                <tr><td><strong>AWS Security Hub</strong></td><td>Security Posture</td><td>Aggregates findings from GuardDuty, Inspector, Macie, etc.</td></tr>
                <tr><td><strong>AWS Config</strong></td><td>Compliance</td><td>Tracks resource configuration changes, compliance rules, remediation</td></tr>
              </tbody>
            </table>
          </div>
        </div>

        <div className="sg-card">
          <h3>Encryption Services</h3>
          <div className="sg-grid2">
            <div>
              <h4>AWS KMS (Key Management Service)</h4>
              <ul>
                <li>Create and manage encryption keys (CMKs)</li>
                <li>AWS-managed keys (free), Customer-managed keys ($1/mo)</li>
                <li>Integrates with S3, EBS, RDS, Redshift, etc.</li>
                <li>Key rotation: automatic (annual) for CMKs</li>
                <li>Key policies control access to keys</li>
                <li>FIPS 140-2 Level 3 compliant with CloudHSM</li>
              </ul>
            </div>
            <div>
              <h4>Encryption at Rest vs In Transit</h4>
              <ul>
                <li><strong>At Rest:</strong> S3 SSE-S3, SSE-KMS, SSE-C; EBS encryption; RDS encryption</li>
                <li><strong>In Transit:</strong> TLS/SSL certificates via ACM; VPN, Direct Connect encryption</li>
                <li><strong>ACM</strong> (Certificate Manager) — free TLS certificates, auto-renew</li>
                <li><strong>Secrets Manager</strong> — store/rotate secrets (DB passwords, API keys)</li>
              </ul>
            </div>
          </div>
        </div>

        <div className="sg-card">
          <h3>Identity Federation & SSO</h3>
          <div className="sg-grid2">
            <div>
              <h4>AWS IAM Identity Center (SSO)</h4>
              <ul>
                <li>Centralised access to multiple AWS accounts</li>
                <li>Connect to Active Directory or external IdP</li>
                <li>SAML 2.0 / OIDC federation</li>
                <li>Permission Sets assigned to users/groups per account</li>
              </ul>
            </div>
            <div>
              <h4>Amazon Cognito</h4>
              <ul>
                <li><strong>User Pools</strong> — user directory, authentication (login/signup)</li>
                <li><strong>Identity Pools</strong> — federated identity, exchange IdP token for AWS credentials</li>
                <li>Supports social logins (Google, Facebook, Apple)</li>
                <li>MFA, password policies, account recovery</li>
              </ul>
            </div>
          </div>
        </div>

        <div className="sg-exam-block">
          <h3>🎯 Exam Questions — Module 6</h3>
          <div className="sg-q">
            <p>Q1. A company wants to detect if any EC2 instance is communicating with known malicious IP addresses. What service should they enable?</p>
            <div className="sg-ans">✅ Amazon GuardDuty — analyses VPC Flow Logs, DNS logs, and CloudTrail events using ML to detect threats including cryptocurrency mining, reconnaissance, compromised instances.</div>
          </div>
          <div className="sg-q">
            <p>Q2. What is the difference between AWS Shield Standard and Shield Advanced?</p>
            <div className="sg-ans">✅ Standard: free, automatic L3/L4 DDoS protection for all customers. Advanced: $3,000/month, adds L7 protection, real-time attack visibility, 24/7 DRT access, and cost protection for scaling caused by attacks.</div>
          </div>
          <div className="sg-q">
            <p>Q3. How should database passwords be stored securely in a serverless application?</p>
            <div className="sg-ans">✅ AWS Secrets Manager — stores secrets encrypted, automatic rotation (Lambda-based), Lambda function retrieves secret at runtime via API (never hardcoded). Can also use SSM Parameter Store with SecureString for simpler cases.</div>
          </div>
        </div>
      </>
    ),
  },
  {
    id: 'm7',
    num: 7,
    title: 'Integration & Architecture Best Practices',
    co: 'CO 1',
    icon: '🏗️',
    content: () => (
      <>
        <div className="sg-card">
          <h3>Messaging & Integration Services</h3>
          <div className="sg-table-wrap">
            <table className="sg-table">
              <thead><tr><th>Service</th><th>Type</th><th>Pattern</th><th>Key Feature</th></tr></thead>
              <tbody>
                <tr><td><strong>SQS</strong></td><td>Queue</td><td>Point-to-point</td><td>Decouple producers/consumers; at-least-once delivery; up to 14-day retention</td></tr>
                <tr><td><strong>SNS</strong></td><td>Pub/Sub Topics</td><td>Fan-out</td><td>Push to multiple subscribers (SQS, Lambda, HTTP, email, SMS)</td></tr>
                <tr><td><strong>EventBridge</strong></td><td>Event Bus</td><td>Event-driven</td><td>AWS service events + custom events; schema registry; SaaS integrations</td></tr>
                <tr><td><strong>Step Functions</strong></td><td>Workflow</td><td>Orchestration</td><td>Visual state machines for multi-step workflows; error handling, retries</td></tr>
                <tr><td><strong>Kinesis Data Streams</strong></td><td>Streaming</td><td>Real-time</td><td>Real-time data ingestion; multiple consumers; retention up to 365 days</td></tr>
                <tr><td><strong>MQ</strong></td><td>Managed Broker</td><td>Protocol bridge</td><td>RabbitMQ/ActiveMQ for lift-and-shift (AMQP, MQTT, STOMP, OpenWire)</td></tr>
              </tbody>
            </table>
          </div>
          <div className="sg-tip"><strong>SQS FIFO vs Standard:</strong> Standard = at-least-once, unlimited throughput. FIFO = exactly-once, ordered, 300 TPS (3,000 with batching).</div>
        </div>

        <div className="sg-card">
          <h3>Well-Architected Framework — 6 Pillars</h3>
          <div className="sg-table-wrap">
            <table className="sg-table">
              <thead><tr><th>Pillar</th><th>Key Principle</th><th>Key Services/Practices</th></tr></thead>
              <tbody>
                <tr><td><strong>Operational Excellence</strong></td><td>Run and monitor systems; continuously improve</td><td>IaC (CloudFormation), CI/CD, runbooks, game days</td></tr>
                <tr><td><strong>Security</strong></td><td>Protect data, systems, assets</td><td>IAM least privilege, encryption, GuardDuty, Config</td></tr>
                <tr><td><strong>Reliability</strong></td><td>Recover from failures; meet demand</td><td>Multi-AZ, Auto Scaling, backups, circuit breakers</td></tr>
                <tr><td><strong>Performance Efficiency</strong></td><td>Use resources efficiently; adapt to change</td><td>Right instance type, serverless, CDN, caching</td></tr>
                <tr><td><strong>Cost Optimisation</strong></td><td>Avoid unnecessary cost</td><td>Reserved Instances, Spot, right-sizing, S3 Lifecycle</td></tr>
                <tr><td><strong>Sustainability</strong></td><td>Minimise environmental impact</td><td>Right-size, managed services, graviton processors</td></tr>
              </tbody>
            </table>
          </div>
        </div>

        <div className="sg-card">
          <h3>Design Patterns</h3>
          <div className="sg-grid2">
            <div>
              <h4>Microservices Patterns</h4>
              <ul>
                <li><strong>API Gateway</strong> — single entry point, auth, rate limiting, transforms</li>
                <li><strong>Service Mesh</strong> — AWS App Mesh, Istio on EKS</li>
                <li><strong>Event-driven</strong> — SNS + SQS for async decoupling</li>
                <li><strong>CQRS</strong> — separate read/write paths</li>
                <li><strong>Saga</strong> — distributed transactions via Step Functions</li>
              </ul>
            </div>
            <div>
              <h4>Resilience Patterns</h4>
              <ul>
                <li><strong>Circuit Breaker</strong> — stop calling failing service temporarily</li>
                <li><strong>Retry with exponential backoff</strong> — built into AWS SDKs</li>
                <li><strong>Dead Letter Queue (DLQ)</strong> — capture failed messages in SQS/SNS</li>
                <li><strong>Multi-AZ + Multi-Region</strong> — eliminate SPOFs</li>
                <li><strong>Health checks + Auto Scaling</strong> — replace unhealthy instances</li>
              </ul>
            </div>
          </div>
        </div>

        <div className="sg-exam-block">
          <h3>🎯 Exam Questions — Module 7</h3>
          <div className="sg-q">
            <p>Q1. A company wants to decouple a web tier from a processing tier so a surge doesn't overwhelm the processors. What pattern should they use?</p>
            <div className="sg-ans">✅ SQS queue between web tier and processors. Web tier puts messages in SQS; processors poll and consume at their own pace. Scale processors based on queue depth (CloudWatch SQS metrics).</div>
          </div>
          <div className="sg-q">
            <p>Q2. An order processing system must trigger notifications to multiple downstream services when an order is placed. What pattern fits?</p>
            <div className="sg-ans">✅ SNS + SQS fan-out pattern. Order service publishes to SNS topic; each downstream service has an SQS queue subscribed to the topic. Provides fan-out + decoupling + independent processing rates.</div>
          </div>
        </div>
      </>
    ),
  },
  {
    id: 'm8',
    num: 8,
    title: 'Migration & Hybrid Architecture',
    co: 'CO 2',
    icon: '🚀',
    content: () => (
      <>
        <div className="sg-card">
          <h3>Migration Strategies — 7 Rs</h3>
          <div className="sg-table-wrap">
            <table className="sg-table">
              <thead><tr><th>Strategy</th><th>Description</th><th>Effort</th><th>When to use</th></tr></thead>
              <tbody>
                <tr><td><strong>Retire</strong></td><td>Decommission the application</td><td>Low</td><td>No longer needed</td></tr>
                <tr><td><strong>Retain</strong></td><td>Keep on-premises for now</td><td>None</td><td>Not ready to migrate</td></tr>
                <tr><td><strong>Rehost</strong> (Lift &amp; Shift)</td><td>Move to EC2 as-is</td><td>Low</td><td>Quick migration, optimise later</td></tr>
                <tr><td><strong>Replatform</strong> (Lift &amp; Reshape)</td><td>Minor optimisation (e.g., RDS instead of EC2+MySQL)</td><td>Medium</td><td>Quick wins without code changes</td></tr>
                <tr><td><strong>Repurchase</strong></td><td>Switch to SaaS (Salesforce, WorkDay)</td><td>Medium</td><td>Replace legacy with SaaS</td></tr>
                <tr><td><strong>Refactor</strong> / Re-architect</td><td>Redesign as cloud-native (microservices, serverless)</td><td>High</td><td>Need to add features, scale, agility</td></tr>
                <tr><td><strong>Relocate</strong></td><td>Move VMware VMs to VMware Cloud on AWS</td><td>Low-Medium</td><td>VMware environment, rapid migration</td></tr>
              </tbody>
            </table>
          </div>
        </div>

        <div className="sg-card">
          <h3>Migration Services</h3>
          <div className="sg-table-wrap">
            <table className="sg-table">
              <thead><tr><th>Service</th><th>Purpose</th></tr></thead>
              <tbody>
                <tr><td><strong>AWS Application Migration Service (MGN)</strong></td><td>Lift-and-shift server replication to AWS (replaces SMS)</td></tr>
                <tr><td><strong>AWS Database Migration Service (DMS)</strong></td><td>Migrate databases to AWS; supports homogeneous + heterogeneous migrations; Schema Conversion Tool (SCT) for heterogeneous</td></tr>
                <tr><td><strong>AWS DataSync</strong></td><td>Automated data transfer from on-premises NFS/SMB/HDFS to S3, EFS, FSx</td></tr>
                <tr><td><strong>AWS Snow Family</strong></td><td>Physical devices for large-scale offline data transfer (Snowcone 8TB, Snowball Edge 80TB, Snowmobile 100PB)</td></tr>
                <tr><td><strong>AWS Transfer for SFTP</strong></td><td>Managed SFTP/FTPS/FTP endpoint backed by S3 or EFS</td></tr>
                <tr><td><strong>Migration Evaluator</strong></td><td>Assess on-premises inventory and project migration costs</td></tr>
              </tbody>
            </table>
          </div>
        </div>

        <div className="sg-card">
          <h3>Hybrid Connectivity</h3>
          <div className="sg-grid2">
            <div>
              <h4>AWS Site-to-Site VPN</h4>
              <ul>
                <li>IPSec VPN over public internet</li>
                <li>Quick to provision (minutes)</li>
                <li>Lower cost but variable latency/bandwidth</li>
                <li>Virtual Private Gateway (VGW) on AWS side</li>
                <li>Customer Gateway (CGW) on on-premises side</li>
                <li>Up to 1.25 Gbps per tunnel (2 tunnels for HA)</li>
              </ul>
            </div>
            <div>
              <h4>AWS Direct Connect</h4>
              <ul>
                <li>Dedicated private network connection (1G or 10G or 100G)</li>
                <li>Consistent latency, higher bandwidth</li>
                <li>Lower data transfer cost vs internet</li>
                <li>Setup takes weeks to months</li>
                <li>Direct Connect + VPN = encrypted private connection</li>
                <li>Direct Connect Gateway — connect to multiple VPCs/regions</li>
              </ul>
            </div>
          </div>
          <div className="sg-tip"><strong>When to use which:</strong> VPN = quick setup, lower cost, tolerates variable latency. Direct Connect = consistent performance, compliance requirements, high throughput workloads.</div>
        </div>

        <div className="sg-card">
          <h3>AWS Outposts & Local Zones</h3>
          <div className="sg-grid2">
            <div>
              <h4>AWS Outposts</h4>
              <ul>
                <li>AWS-managed hardware in your data center</li>
                <li>Run EC2, ECS, EKS, RDS on-premises</li>
                <li>Low latency to on-premises systems</li>
                <li>Data residency requirements</li>
                <li>AWS manages hardware, you own the facility</li>
              </ul>
            </div>
            <div>
              <h4>AWS Local Zones</h4>
              <ul>
                <li>AWS infrastructure placed in metro areas</li>
                <li>Single-digit ms latency to end users</li>
                <li>Extension of a parent AWS Region</li>
                <li>Use cases: media rendering, AR/VR, gaming</li>
                <li>Subset of services available vs full region</li>
              </ul>
            </div>
          </div>
        </div>

        <div className="sg-exam-block">
          <h3>🎯 Exam Questions — Module 8</h3>
          <div className="sg-q">
            <p>Q1. A company needs to migrate 500TB of data to S3 but has limited bandwidth. What should they use?</p>
            <div className="sg-ans">✅ AWS Snowball Edge — physical device shipped to customer, load data, ship back to AWS. For 500TB consider multiple Snowball Edge devices. Snowmobile for 100PB+.</div>
          </div>
          <div className="sg-q">
            <p>Q2. What is the fastest way to establish connectivity between on-premises and AWS?</p>
            <div className="sg-ans">✅ AWS Site-to-Site VPN — can be provisioned in minutes via the console. Direct Connect takes weeks/months to provision the physical connection.</div>
          </div>
        </div>
      </>
    ),
  },
  {
    id: 'cases',
    num: '★',
    title: 'Case Studies',
    co: 'All COs',
    icon: '📋',
    content: () => (
      <>
        <div className="sg-card">
          <h3>Case Study 1 — E-Commerce Platform Scaling</h3>
          <div className="sg-warn"><strong>Scenario:</strong> Online retailer expecting 10× traffic spikes during peak sales. Current monolithic application on a single EC2 instance. Requirements: high availability, automatic scaling, cost efficiency.</div>
          <h4>Solution Architecture</h4>
          <ul>
            <li><strong>Multi-AZ deployment:</strong> EC2 instances across 2+ AZs behind ALB</li>
            <li><strong>Auto Scaling Group:</strong> Min 2 / desired 4 / max 20; target-tracking CPU 60%</li>
            <li><strong>RDS Multi-AZ:</strong> Aurora MySQL with 2 read replicas for read offloading</li>
            <li><strong>ElastiCache Redis:</strong> Session storage, product catalog caching</li>
            <li><strong>CloudFront + S3:</strong> Static assets (images, JS, CSS) served from edge</li>
            <li><strong>SQS:</strong> Order processing queue to decouple checkout from fulfilment</li>
            <li><strong>Reserved Instances (3yr):</strong> Base 2 instances; Spot for burst capacity</li>
          </ul>
          <div className="sg-tip"><strong>Cost saving:</strong> Reserved for baseline + Spot for burst can reduce compute costs by 60-70% vs all On-Demand.</div>
        </div>

        <div className="sg-card">
          <h3>Case Study 2 — Global Media Streaming Service</h3>
          <div className="sg-warn"><strong>Scenario:</strong> Video streaming service serving users in 50 countries. Requirements: low latency globally, 99.99% uptime, petabyte-scale storage, real-time analytics on viewing patterns.</div>
          <h4>Solution Architecture</h4>
          <ul>
            <li><strong>Multi-region active-active:</strong> Deploy in US-East, EU-West, AP-Southeast</li>
            <li><strong>Route 53 Latency routing:</strong> Route users to nearest region</li>
            <li><strong>CloudFront:</strong> Cache video segments at 400+ edge locations</li>
            <li><strong>S3 (Standard + Intelligent-Tiering):</strong> Video storage with lifecycle policies</li>
            <li><strong>AWS Elemental MediaConvert:</strong> Transcode video to multiple formats/resolutions</li>
            <li><strong>DynamoDB Global Tables:</strong> User preferences, watch history (multi-region)</li>
            <li><strong>Kinesis Data Streams + Kinesis Analytics:</strong> Real-time viewing analytics</li>
            <li><strong>AWS Redshift:</strong> Business intelligence on historical viewing data</li>
          </ul>
        </div>

        <div className="sg-card">
          <h3>Case Study 3 — Financial Services Compliance Migration</h3>
          <div className="sg-warn"><strong>Scenario:</strong> Bank migrating core banking application to AWS. Requirements: data residency in specific region, encryption everywhere, audit trail for all access, DR with RPO &lt; 1hr / RTO &lt; 4hr.</div>
          <h4>Solution Architecture</h4>
          <ul>
            <li><strong>Region lock:</strong> Deploy in compliant region; SCP blocks other regions</li>
            <li><strong>KMS CMKs:</strong> Customer-managed keys for all data encryption</li>
            <li><strong>CloudHSM:</strong> FIPS 140-2 Level 3 for key storage (compliance requirement)</li>
            <li><strong>CloudTrail + Config:</strong> All API calls + resource config changes logged</li>
            <li><strong>Security Hub + GuardDuty:</strong> Continuous threat monitoring</li>
            <li><strong>RDS Multi-AZ Oracle:</strong> Synchronous replication; automated backups to S3</li>
            <li><strong>AWS Backup:</strong> Centralised backup with cross-region copy for DR</li>
            <li><strong>Direct Connect:</strong> Dedicated connectivity from on-premises to AWS</li>
            <li><strong>AWS DRS (Disaster Recovery Service):</strong> Sub-second RPO, RTO minutes-to-hours</li>
          </ul>
        </div>
      </>
    ),
  },
  {
    id: 'quick',
    num: '⚡',
    title: 'Quick Reference',
    co: 'All',
    icon: '⚡',
    content: () => (
      <>
        <div className="sg-card">
          <h3>Service Selection — Fast Decisions</h3>
          <div className="sg-table-wrap">
            <table className="sg-table">
              <thead><tr><th>Need</th><th>Use This</th><th>Not This</th></tr></thead>
              <tbody>
                <tr><td>Run containers without managing servers</td><td>ECS Fargate / EKS Fargate</td><td>EC2 (manual cluster)</td></tr>
                <tr><td>Short-lived functions, event-driven</td><td>AWS Lambda</td><td>EC2 (over-engineered)</td></tr>
                <tr><td>Relational DB, managed, HA</td><td>RDS Multi-AZ or Aurora</td><td>DB on EC2 (self-managed)</td></tr>
                <tr><td>Key-value store, millisecond latency</td><td>DynamoDB</td><td>RDS (wrong data model)</td></tr>
                <tr><td>Cache database reads</td><td>ElastiCache Redis/Memcached</td><td>DAX (DynamoDB only)</td></tr>
                <tr><td>Decouple async tasks (queue)</td><td>SQS</td><td>SNS (push, not queue)</td></tr>
                <tr><td>Fan-out to multiple subscribers</td><td>SNS + SQS</td><td>SQS alone</td></tr>
                <tr><td>Multi-step workflow with error handling</td><td>Step Functions</td><td>Lambda chaining</td></tr>
                <tr><td>Real-time streaming data</td><td>Kinesis Data Streams</td><td>SQS (not real-time)</td></tr>
                <tr><td>OLAP analytics, SQL queries on data lake</td><td>Athena (S3) or Redshift</td><td>DynamoDB (OLTP)</td></tr>
                <tr><td>Static website hosting</td><td>S3 + CloudFront</td><td>EC2 web server (costly)</td></tr>
                <tr><td>Secret rotation (DB passwords)</td><td>Secrets Manager</td><td>SSM Parameter Store (no auto-rotation)</td></tr>
                <tr><td>SSL/TLS certificate (free)</td><td>ACM</td><td>Self-signed or external CA</td></tr>
                <tr><td>Web application firewall</td><td>WAF + ALB or CloudFront</td><td>Security Groups (can't inspect HTTP)</td></tr>
                <tr><td>Large-scale offline data transfer</td><td>Snowball Edge</td><td>DataSync over internet (too slow)</td></tr>
              </tbody>
            </table>
          </div>
        </div>

        <div className="sg-card">
          <h3>Key Numbers to Remember</h3>
          <div className="sg-grid2">
            <div>
              <h4>S3</h4>
              <ul>
                <li>Max object size: 5 TB</li>
                <li>Multipart upload required: &gt;100 MB recommended, required &gt;5 GB</li>
                <li>Presigned URL max expiry: 7 days</li>
                <li>99.999999999% (11 nines) durability</li>
              </ul>
              <h4>Lambda</h4>
              <ul>
                <li>Max execution time: 15 min</li>
                <li>Memory: 128 MB – 10,240 MB</li>
                <li>Default concurrent executions: 1,000/region</li>
                <li>Deployment package (zip): 50 MB (250 MB unzipped)</li>
              </ul>
            </div>
            <div>
              <h4>SQS</h4>
              <ul>
                <li>Max message size: 256 KB</li>
                <li>Max retention: 14 days</li>
                <li>Visibility timeout: 30s default (up to 12 hr)</li>
                <li>FIFO throughput: 300 TPS (3,000 with batching)</li>
              </ul>
              <h4>VPC</h4>
              <ul>
                <li>Max VPCs per region: 5 (soft limit)</li>
                <li>Max subnets per VPC: 200</li>
                <li>Max security groups per ENI: 5</li>
                <li>Max rules per security group: 60 inbound + 60 outbound</li>
              </ul>
            </div>
          </div>
        </div>
      </>
    ),
  },
  {
    id: 'exam',
    num: '📝',
    title: 'Practice Exam',
    co: 'All COs',
    icon: '📝',
    content: () => (
      <>
        <div className="sg-exam-block">
          <h3>Section A — Short Answer (16 Questions)</h3>
          {[
            { q: 'Q1. What does "stateless" mean in the context of NACLs?', a: 'NACLs do not track connection state. Each packet is evaluated independently. You must explicitly allow both inbound AND outbound traffic (request + response). Unlike Security Groups which are stateful (response traffic is auto-allowed).' },
            { q: 'Q2. What is an Availability Zone?', a: 'One or more discrete data centers with redundant power, networking, and connectivity within a Region. Physically separated to isolate failures. AZs within a Region are connected via low-latency high-bandwidth private fiber.' },
            { q: 'Q3. What is the difference between S3 Standard-IA and S3 One Zone-IA?', a: 'Standard-IA: data stored across ≥3 AZs (99.9% availability). One Zone-IA: data stored in a single AZ (99.5% availability, ~20% cheaper). Use One Zone-IA for data that can be regenerated or replicated from elsewhere.' },
            { q: 'Q4. When would you use Spot Instances?', a: 'Fault-tolerant, flexible workloads that can tolerate interruption: batch processing, CI/CD pipelines, big data analytics, rendering farms. NOT for stateful production databases or applications that cannot checkpoint and resume.' },
            { q: 'Q5. What is an IAM Permission Boundary?', a: 'An IAM policy that sets the maximum permissions an IAM entity (user or role) can have. The effective permissions are the intersection of identity-based policies AND the permission boundary. Used to delegate admin capabilities with guardrails.' },
            { q: 'Q6. How does Aurora differ from RDS MySQL?', a: 'Aurora uses a distributed storage layer (6 copies across 3 AZs), is 5× faster, auto-grows storage, supports up to 15 replicas with sub-10ms replica lag, and has automatic failover. RDS MySQL uses traditional replication (synchronous for Multi-AZ, async for read replicas).' },
            { q: 'Q7. What is the purpose of VPC Endpoints?', a: 'VPC Endpoints allow private connectivity between VPC and supported AWS services without internet, NAT, VPN, or Direct Connect. Gateway endpoints: S3 and DynamoDB (free). Interface endpoints: most other services (powered by PrivateLink, hourly + data charge).' },
            { q: 'Q8. What is CloudFront OAC (Origin Access Control)?', a: 'OAC restricts S3 bucket access so only CloudFront can read it. Prevents direct public S3 access. Use S3 bucket policy that allows only the CloudFront distribution. Replaces legacy OAI (Origin Access Identity).' },
            { q: 'Q9. What is the difference between RPO and RTO?', a: 'RPO (Recovery Point Objective): max acceptable data loss — how much data can you lose? Drives backup/replication frequency. RTO (Recovery Time Objective): max acceptable downtime — how fast must you recover? Drives failover automation and DR complexity.' },
            { q: 'Q10. What AWS service helps detect unusual spend patterns?', a: 'AWS Budgets (alerts on threshold %) + Cost Explorer (trend analysis). AWS Anomaly Detection (ML-based spend anomaly alerts within Cost Explorer). Trusted Advisor checks for cost optimization opportunities.' },
            { q: 'Q11. What is an SCP and who can it restrict?', a: 'Service Control Policy — an Organizations policy that restricts permissions for all IAM entities in a member account, including the root user of that account. SCPs do NOT apply to the management account of the organization.' },
            { q: 'Q12. When should you use DynamoDB vs RDS?', a: 'DynamoDB: unstructured/semi-structured data, need unlimited scale, known access patterns, single-digit ms latency required. RDS: structured relational data, complex joins/queries, ACID transactions, existing SQL workloads, reporting.' },
            { q: 'Q13. What is Lambda@Edge and when would you use it?', a: 'Lambda functions that run at CloudFront edge locations (not a Region). Triggered by CloudFront events (viewer request/response, origin request/response). Use for: A/B testing, authentication at edge, URL rewrites, personalisation without origin round-trip.' },
            { q: 'Q14. How does AWS Shield Advanced differ from WAF?', a: 'Shield Advanced: protects against volumetric DDoS attacks (L3/L4/L7), provides 24/7 DRT access, attack cost protection. WAF: filters HTTP/HTTPS at L7 based on rules (SQLi, XSS, rate limits). They are complementary and often used together.' },
            { q: 'Q15. What is the purpose of Dead Letter Queues (DLQ)?', a: 'A DLQ captures messages that could not be successfully processed (after MaxReceiveCount retries for SQS, or after all retries for Lambda async invocations). Prevents message loss and allows investigation of processing failures.' },
            { q: 'Q16. What is AWS Transit Gateway?', a: 'A network transit hub that connects hundreds of VPCs and on-premises networks in a hub-and-spoke topology. Eliminates complex VPC peering meshes. Supports inter-region peering, multicast, and route tables for traffic segmentation.' },
          ].map(({ q, a }, i) => (
            <div className="sg-q" key={i}>
              <p>{q}</p>
              <div className="sg-ans">✅ {a}</div>
            </div>
          ))}
        </div>

        <div className="sg-exam-block" style={{marginTop:'1.5rem'}}>
          <h3>Section B — Multiple Choice</h3>
          {[
            {
              q: 'Q17. A company wants to ensure their S3 bucket is never made public, even by mistake. What is the MOST effective control?',
              opts: ['A. Bucket policy denying public access', 'B. S3 Block Public Access at account level', 'C. SCP denying s3:PutBucketPolicy', 'D. IAM policy denying s3:PutBucketAcl'],
              a: 'B',
              exp: 'S3 Block Public Access at the account level overrides all bucket-level and object-level settings. It acts as a guardrail that prevents any bucket in the account from being made public, even if a bucket policy tries to allow it.',
            },
            {
              q: 'Q18. An application sends 1,000 messages per second to SQS and processes them with Lambda. Some messages fail processing and must not be lost. What should be configured?',
              opts: ['A. Increase visibility timeout', 'B. Enable SQS FIFO', 'C. Configure a Dead Letter Queue on the SQS queue', 'D. Set Lambda reserved concurrency to 1,000'],
              a: 'C',
              exp: 'A Dead Letter Queue captures messages that fail MaxReceiveCount times. This prevents message loss while allowing investigation of failures. The DLQ is an SQS queue itself where failed messages land.',
            },
            {
              q: 'Q19. Which service would you use to run container workloads without managing any EC2 instances?',
              opts: ['A. ECS on EC2 launch type', 'B. ECS on Fargate launch type', 'C. EKS self-managed nodes', 'D. EC2 Auto Scaling with Docker'],
              a: 'B',
              exp: 'ECS Fargate (and EKS Fargate) is a serverless compute engine for containers. You define the container requirements (CPU/memory) and Fargate provisions and manages the underlying infrastructure automatically.',
            },
            {
              q: 'Q20. A startup needs to process data only when it arrives and wants to minimise costs when there is no traffic. What compute option is best?',
              opts: ['A. EC2 On-Demand', 'B. EC2 Reserved', 'C. AWS Lambda', 'D. EC2 Spot'],
              a: 'C',
              exp: 'Lambda charges only for actual execution time (per millisecond) and invocations. When there is no traffic, there is zero cost. No idle server costs. Auto-scales automatically for bursts.',
            },
          ].map(({ q, opts, a, exp }, i) => (
            <div className="sg-q" key={i} style={{marginBottom:'1.5rem'}}>
              <p>{q}</p>
              <ul style={{marginBottom:'0.5rem'}}>
                {opts.map((o, j) => <li key={j} style={{fontWeight: o.startsWith(a) ? '700' : 'normal', color: o.startsWith(a) ? 'var(--success-text, #2e7d32)' : undefined}}>{o}</li>)}
              </ul>
              <div className="sg-ans">✅ Answer: {a} — {exp}</div>
            </div>
          ))}
        </div>
      </>
    ),
  },
];

export default function AWSStudyGuide() {
  const [activeId, setActiveId] = useState('m1');
  const sectionRefs = useRef({});
  const observerRef = useRef(null);

  useEffect(() => {
    const options = { root: null, rootMargin: '-20% 0px -70% 0px', threshold: 0 };
    observerRef.current = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) setActiveId(entry.target.id);
      });
    }, options);
    Object.values(sectionRefs.current).forEach((el) => {
      if (el) observerRef.current.observe(el);
    });
    return () => observerRef.current?.disconnect();
  }, []);

  const scrollTo = (id) => {
    sectionRefs.current[id]?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <div className="sg-root">
      <style>{CSS}</style>
      <div className="sg-hero">
        <h1>☁️ AWS Cloud Study Guide</h1>
        <p>Comprehensive coverage of all 8 modules, case studies, quick-reference tables, and practice exam.</p>
        <div className="sg-hero-meta">
          {MODULES.map(m => (
            <span key={m.id} className="sg-badge">{m.icon} {m.co !== 'All COs' && m.co !== 'All' ? `${m.co}: ` : ''}{m.title}</span>
          ))}
        </div>
      </div>

      <div className="sg-layout">
        <nav className="sg-nav">
          <div className="sg-nav-inner">
            <h3>Modules</h3>
            {MODULES.map(m => (
              <a
                key={m.id}
                href={`#${m.id}`}
                className={activeId === m.id ? 'active' : ''}
                onClick={(e) => { e.preventDefault(); scrollTo(m.id); }}
              >
                <span className="sg-nav-num">{m.num}</span>
                {m.title}
              </a>
            ))}
          </div>
        </nav>

        <main className="sg-main">
          {MODULES.map(m => (
            <section
              key={m.id}
              id={m.id}
              className="sg-section"
              ref={(el) => { sectionRefs.current[m.id] = el; }}
            >
              <div className="sg-section-header">
                <div className="sg-section-num">{m.num}</div>
                <h2 className="sg-section-title">{m.icon} {m.title}</h2>
                <span className="sg-section-co">{m.co}</span>
              </div>
              {m.content()}
            </section>
          ))}
        </main>
      </div>
    </div>
  );
}
